/* BMG collection refinement. Enhances existing cards; does not alter prices or filtering. */
(() => {
  'use strict';
  const version = '2026-10-11-collection-1';
  if (window.BMGCollectionRefinement) { window.BMGCollectionRefinement.init(); return; }
  const instances = new Map();
  const preferenceKey = 'bmg:collection-view:v1';
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) { return null; } };
  const store = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  const plainClick = e => e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
  const safeURL = (value, image = false) => {
    try {
      const url = new URL(value, location.href);
      if (url.protocol !== 'https:' && url.origin !== location.origin) return '';
      if (!image && url.origin !== location.origin) return '';
      if (image && url.origin !== location.origin && url.hostname !== 'cdn.shopify.com') return '';
      return url.href;
    } catch (_) { return ''; }
  };
  function mount(root) {
    if (instances.has(root)) return;
    const grid = root.querySelector('.bmg-print-shop__grid');
    const template = document.querySelector('[data-bmg-art-viewer-template]');
    if (!grid || !template || !window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
    const abort = new AbortController();
    const on = (target, name, fn, options = {}) => target?.addEventListener(name, fn, {...options, signal:abort.signal});
    const dialog = template.content.querySelector('dialog').cloneNode(true);
    document.body.append(dialog);
    const $ = selector => dialog.querySelector(selector);
    const figure = $('[data-viewer-figure]'), photo = $('[data-viewer-image]');
    const previous = $('[data-viewer-prev]'), next = $('[data-viewer-next]');
    const close = $('[data-viewer-close]'), title = $('[data-viewer-title]');
    const locationLabel = $('[data-viewer-location]'), details = $('[data-viewer-details]');
    const product = $('[data-viewer-product]'), favouriteSlot = $('[data-viewer-favourite]');
    const count = $('[data-viewer-count]'), status = $('[data-viewer-status]');
    const collectionLabel = $('[data-viewer-collection]');
    collectionLabel.textContent = root.querySelector('h1')?.textContent.trim() || 'The photographs';
    const locations = new Map();
    document.querySelectorAll('[data-bmg-location-template]').forEach(meta => {
      meta.content.querySelectorAll('[data-bmg-location-for]').forEach(el => locations.set(el.dataset.bmgLocationFor, el.dataset.bmgLocation || ''));
    });
    const enhanced = new Map();
    let raf = 0, restoreFrame = 0, selection = [], index = -1, opener = null;
    let savedPosition = null, bodyStyles = null, requestedImage = null, requestNumber = 0;
    let viewInitialised = false, pointer = null, lastFrame = null;
    const bodyProperties = ['position','top','left','right','width','overflow','padding-right'];
    function lock() {
      if (savedPosition) return;
      savedPosition = {x:scrollX, y:scrollY};
      bodyStyles = bodyProperties.map(name => [name,document.body.style.getPropertyValue(name),document.body.style.getPropertyPriority(name)]);
      const scrollbar = innerWidth - document.documentElement.clientWidth;
      const currentPadding = parseFloat(getComputedStyle(document.body).paddingRight) || 0;
      document.body.style.setProperty('position','fixed');
      document.body.style.setProperty('top',-savedPosition.y+'px');
      document.body.style.setProperty('left','0'); document.body.style.setProperty('right','0');
      document.body.style.setProperty('width','100%'); document.body.style.setProperty('overflow','hidden');
      if (scrollbar > 0) document.body.style.setProperty('padding-right',currentPadding+scrollbar+'px');
    }
    function unlock(restoreFocus = true) {
      if (!savedPosition) return;
      const pos = savedPosition; savedPosition = null;
      bodyStyles.forEach(([name,value,priority]) => value ? document.body.style.setProperty(name,value,priority) : document.body.style.removeProperty(name));
      bodyStyles = null;
      scrollTo({left:pos.x,top:pos.y,behavior:'instant'});
      if (restoreFocus && opener?.isConnected && !opener.closest('[hidden]')) opener.focus({preventScroll:true});
      restoreFrame = requestAnimationFrame(() => scrollTo({left:pos.x,top:pos.y,behavior:'instant'}));
    }
    function enhance(card) {
      if (enhanced.has(card)) return;
      const media = card.querySelector('.bmg-print-shop__media');
      const link = card.querySelector('.bmg-print-shop__card-link');
      const image = card.querySelector('.bmg-print-shop__image');
      if (!media || !link) return;
      const original = [...card.childNodes];
      const ratio = Math.max(.15,Number(image?.getAttribute('width')) / (Number(image?.getAttribute('height')) || 1) || 1);
      const format = ratio >= 2.3 ? 'panorama' : ratio < 1 ? 'portrait' : 'landscape';
      const work = document.createElement('div'); work.className = 'bmg-study-work';
      work.style.setProperty('--bmg-work-ratio',String(ratio));
      const caption = document.createElement('div'); caption.className = 'bmg-study-caption';
      const actions = document.createElement('div'); actions.className = 'bmg-study-actions';
      const fav = media.querySelector('[data-bmg-favourite-toggle]');
      const trigger = media.querySelector('[data-bmg-quick-look]');
      const release = media.querySelector('.bmg-print-shop__release-flag');
      const place = locations.get(card.dataset.handle);
      let locationElement;
      if (place) {
        locationElement = document.createElement('p'); locationElement.className = 'bmg-study-location';
        locationElement.textContent = place;
        link.querySelector('h2')?.after(locationElement);
      }
      if (release) { release.classList.add('bmg-study-release'); link.querySelector('.bmg-print-shop__meta > div')?.append(release); }
      if (trigger) {
        trigger.removeAttribute('data-bmg-quick-look'); trigger.setAttribute('data-bmg-view-larger','');
        trigger.classList.add('bmg-study-enlarge');
        trigger.textContent = template.dataset.enlargeLabel || 'View larger';
        trigger.setAttribute('aria-label','View '+card.dataset.title+' larger');
        actions.append(trigger);
      }
      if (fav) actions.append(fav);
      caption.append(link,actions); work.append(media,caption); card.append(work);
      card.dataset.bmgStudyFormat = format;
      enhanced.set(card,{original,work,media,link,trigger,fav,release,locationElement});
    }
    function scan() {
      raf = 0;
      const cards = [...grid.querySelectorAll('.bmg-print-shop__card')];
      cards.forEach(enhance);
      const visible = cards.filter(c => !c.hidden && c.style.display !== 'none');
      // A solitary normal-format work before a panorama gets a centred mobile row.
      let pending = null;
      visible.forEach(card => {
        card.removeAttribute('data-bmg-grid-solo');
        if (card.dataset.bmgStudyFormat === 'panorama') {
          if (pending) pending.setAttribute('data-bmg-grid-solo',''); pending = null;
        } else if (pending) pending = null; else pending = card;
      });
      if (pending) pending.setAttribute('data-bmg-grid-solo','');
      const toolbar = root.querySelector('.bmg-v2-viewbar');
      if (toolbar && !viewInitialised) {
        viewInitialised = true;
        const saved = read(preferenceKey);
        if (saved === 'gallery' || saved === 'grid') toolbar.querySelector('[data-bmg-v2-view="'+saved+'"]')?.click();
      }
      root.classList.add('bmg-collection-refined');
    }
    const schedule = () => { if (!raf) raf=requestAnimationFrame(scan); };
    const observer = new MutationObserver(schedule);
    observer.observe(grid,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden']});
    on(root,'click',e => {
      const view = e.target.closest('[data-bmg-v2-view]');
      if (view) { store(preferenceKey,view.dataset.bmgV2View); schedule(); }
      const trigger=e.target.closest('[data-bmg-view-larger]');
      if (!trigger || !root.contains(trigger)) return;
      e.preventDefault(); open(trigger);
    });
    on(grid,'load',schedule,{capture:true});
    function selectedCards() {
      const edition = root.querySelector('[data-bmg-edition-filter]')?.value || root.dataset.defaultEdition || 'all';
      const sort = root.querySelector('[data-bmg-sort]')?.value || 'manual';
      const curated=['outback-australia','wildlife','coast-ocean','forests-water','latest-release'].includes(root.dataset.bmgBrowseCategory);
      const featured=curated?[]:['zillie-falls','reach','noah-beach','after-burn-1','apex','boat-shed'];
      return [...grid.querySelectorAll('.bmg-print-shop__card')].filter(c => (edition==='all'||c.dataset.edition===edition) && c.querySelector('[data-bmg-view-larger]')).sort((a,b) => {
        switch(sort) {
          case 'created-descending':return Number(b.dataset.created)-Number(a.dataset.created)||Number(a.dataset.order)-Number(b.dataset.order);
          case 'created-ascending':return Number(a.dataset.created)-Number(b.dataset.created)||Number(a.dataset.order)-Number(b.dataset.order);
          case 'price-ascending':return Number(a.dataset.price)-Number(b.dataset.price)||Number(a.dataset.order)-Number(b.dataset.order);
          case 'price-descending':return Number(b.dataset.price)-Number(a.dataset.price)||Number(a.dataset.order)-Number(b.dataset.order);
          case 'title-ascending':return a.dataset.title.localeCompare(b.dataset.title)||Number(a.dataset.order)-Number(b.dataset.order);
          case 'title-descending':return b.dataset.title.localeCompare(a.dataset.title)||Number(a.dataset.order)-Number(b.dataset.order);
          case 'manual': {const ai=featured.indexOf(a.dataset.handle),bi=featured.indexOf(b.dataset.handle);return(ai<0?999:ai)-(bi<0?999:bi)||Number(a.dataset.order)-Number(b.dataset.order);}
          default:return Number(a.dataset.order)-Number(b.dataset.order);
        }
      });
    }
    function show(target) {
      if (target<0 || target>=selection.length) return;
      index=target;
      const card=selection[index], trigger=card.querySelector('[data-bmg-view-larger]');
      if(!trigger)return;
      const thumbnail=card.querySelector('.bmg-print-shop__image');
      const thumbURL=safeURL(thumbnail?.currentSrc||thumbnail?.src||'',true);
      const fullURL=safeURL(trigger.dataset.image||'',true);
      const token=++requestNumber;
      if(requestedImage){requestedImage.onload=null;requestedImage.onerror=null;}
      title.textContent=card.dataset.title||'Artwork';
      const place=locations.get(card.dataset.handle)||'';
      locationLabel.textContent=place; locationLabel.hidden=!place;
      const edition=trigger.dataset.editionLabel||'';
      const price=card.querySelector('.bmg-print-shop__price')?.textContent.trim()||'';
      details.textContent=[edition,price].filter(Boolean).join(' · ');
      product.href=safeURL(trigger.dataset.productUrl)||'#';
      photo.width=Number(trigger.dataset.imageWidth)||1; photo.height=Number(trigger.dataset.imageHeight)||1;
      photo.alt=trigger.dataset.alt||card.dataset.title||'Artwork';
      if(thumbURL)photo.src=thumbURL;else photo.removeAttribute('src');
      count.textContent=String(index+1)+' / '+selection.length;
      previous.disabled=index===0; next.disabled=index===selection.length-1;
      favouriteSlot.replaceChildren();
      const source=card.querySelector('[data-bmg-favourite-toggle]');
      if(source){
        const button=source.cloneNode(true);button.classList.add('bmg-viewer-save');
        const label=document.createElement('span');label.setAttribute('data-bmg-favourite-label','');
        label.textContent=source.getAttribute('aria-pressed')==='true'?'Saved to favourites':'Save to favourites';
        button.append(label); favouriteSlot.append(button);
      }
      status.textContent='';
      if(fullURL){
        figure.setAttribute('aria-busy','true');
        requestedImage=new Image();requestedImage.decoding='async';
        requestedImage.onload=()=>{if(token!==requestNumber)return;photo.src=fullURL;figure.setAttribute('aria-busy','false');};
        requestedImage.onerror=()=>{if(token!==requestNumber)return;figure.setAttribute('aria-busy','false');status.textContent='The full-size image could not load. Preview shown.';};
        requestedImage.src=fullURL;
      }else figure.setAttribute('aria-busy','false');
      lastFrame?.cancel();
      if(!motion.matches && document.querySelector('[data-bmg-v2-config]')?.dataset.motion!=='false' && photo.animate){
        lastFrame=photo.animate([{opacity:.55},{opacity:1}],{duration:160,easing:'ease-out'});
      }
    }
    function open(trigger) {
      cancelAnimationFrame(restoreFrame);
      scan(); selection=selectedCards();
      const position=selection.indexOf(trigger.closest('.bmg-print-shop__card'));
      if(position<0)return;
      opener=trigger; lock();
      try { show(position); if(!dialog.open)dialog.showModal(); close.focus({preventScroll:true}); }
      catch(_) { unlock(); }
    }
    function step(direction){show(index+direction);}
    on(previous,'click',()=>step(-1));on(next,'click',()=>step(1));
    on(close,'click',()=>dialog.close());
    on(dialog,'click',e=>{if(e.target===dialog)dialog.close();});
    on(dialog,'close',()=>{++requestNumber;lastFrame?.cancel();unlock();});
    on(dialog,'keydown',e=>{
      if(e.altKey||e.ctrlKey||e.metaKey||e.shiftKey)return;
      if(e.key==='ArrowRight'){e.preventDefault();step(1);}else if(e.key==='ArrowLeft'){e.preventDefault();step(-1);}
    });
    // Do not claim a swipe while the visitor is zooming, pinching or scrolling vertically.
    on(figure,'pointerdown',e=>{
      if(!e.isPrimary || (window.visualViewport?.scale||1)>1.02){pointer=null;return;}
      if(e.pointerType!=='touch')return;
      pointer={id:e.pointerId,x:e.clientX,y:e.clientY,time:performance.now()};
    },{passive:true});
    on(figure,'pointercancel',()=>{pointer=null;},{passive:true});
    on(figure,'pointerup',e=>{
      const start=pointer;pointer=null;if(!start||start.id!==e.pointerId)return;
      const dx=e.clientX-start.x,dy=e.clientY-start.y;
      if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.6&&performance.now()-start.time<850&&(window.visualViewport?.scale||1)<=1.02)step(dx<0?1:-1);
    },{passive:true});
    on(product,'click',e=>{
      if(!plainClick(e)||index<0)return;
      const card=selection[index];
      // Keep the original gallery page/scroll position even when browsing further in the viewer.
      store('bmg-v2-gallery',{url:location.href,y:savedPosition?.y??scrollY,handle:card.dataset.handle,time:Date.now()});
    });
    on(window,'pagehide',()=>{if(dialog.open)dialog.close();unlock(false);});
    function dispose(){
      abort.abort();observer.disconnect();cancelAnimationFrame(raf);cancelAnimationFrame(restoreFrame);lastFrame?.cancel();
      if(dialog.open)dialog.close();unlock(false);dialog.remove();++requestNumber;
      if(requestedImage){requestedImage.onload=null;requestedImage.onerror=null;}
      enhanced.forEach(({original,work,media,trigger,fav,release,locationElement},card)=>{
        if(fav)media.append(fav);
        if(trigger){trigger.setAttribute('data-bmg-quick-look','');trigger.removeAttribute('data-bmg-view-larger');trigger.classList.remove('bmg-study-enlarge');trigger.textContent='Quick look';trigger.setAttribute('aria-label','Quick look at '+card.dataset.title);media.append(trigger);}
        if(release){release.classList.remove('bmg-study-release');media.prepend(release);}
        locationElement?.remove(); original.forEach(node=>card.append(node));work.remove();
        card.removeAttribute('data-bmg-study-format');card.removeAttribute('data-bmg-grid-solo');
      });
      root.classList.remove('bmg-collection-refined');instances.delete(root);
    }
    instances.set(root,dispose);scan();
  }
  function init(){document.querySelectorAll('[data-bmg-catalogue]').forEach(mount);}
  document.addEventListener('shopify:section:load',()=>{[...instances.values()].forEach(dispose=>dispose());init();});
  document.addEventListener('shopify:section:unload',e=>{[...instances.entries()].forEach(([root,dispose])=>{if(e.target.contains(root))dispose();});});
  window.addEventListener('pageshow',init);
  window.BMGCollectionRefinement={version,init};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
